import {Fragment, observer, React, utils} from '@api'
import {MenuDivider} from "@blueprintjs/core"
import {ContextMenuItem, ContextMenuItemProps, DefaultCatalogContextMenuItems, openInNewTab, useStores} from '@modules'
import {icons} from '@stores/ui'

export type ISeasonalBreadcrumbContextMenuExtra = { item: any, type: string }
export const SeasonalBreadcrumbContextMenu = observer(function SeasonalBreadcrumbContextMenu() {
  const {strings, contextMenu: {extra}} = useStores(),
    {item, type} = extra as ISeasonalBreadcrumbContextMenuExtra

  console.log(item, type)

  //https://gant-vlp-c8-dev.centricsoftware.com/WebAccess/login.html#URL=C8^C241744&Tab=Configuration&Tab1=Business%20Objects&SessionURL=centric://SESSION/dd75f3cd-8c38-4d7a-943d-d75744afc3cb#URL=C8%5EC241744
  // https://gant-vlp-c8-dev.centricsoftware.com/WebAccess/home.html#URL=C8%5EC241744&RURL=&Tab=Target
  //https://gant-vlp-c8-dev.centricsoftware.com/WebAccess/home.html#URL=C8^C241744&Tab=Configuration&Tab1=Business%20Objects&SessionURL=centric://SESSION/dd75f3cd-8c38-4d7a-943d-d75744afc3cb#URL=C8%5EC241744
  return <Fragment>
    <OpenInC8MenuItem id={item?.id} />
    <MenuDivider />
    <DefaultCatalogContextMenuItems/>
  </Fragment>
})

export const OpenInC8MenuItem = observer<{id: string} & ContextMenuItemProps>(function OpenInC8MenuItem({id, ...props}) {
  const {strings} = useStores()
  return id ? (
    <ContextMenuItem {...props} icon={icons.c8}
                   text={strings.openInPLM}
                   onClick={() => openInNewTab(utils.plmLinkForId(id))}
  />) : null
})



// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/SeasonalBreadcrumbContextMenu.tsx